import { render, staticRenderFns } from "./spacestation_blog.vue?vue&type=template&id=2caf9ab6&scoped=true&"
import script from "./spacestation_blog.vue?vue&type=script&lang=ts&"
export * from "./spacestation_blog.vue?vue&type=script&lang=ts&"
import style0 from "./spacestation_blog.vue?vue&type=style&index=0&id=2caf9ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf9ab6",
  null
  
)

export default component.exports